import { trackDelivery } from './adTracking';

function trackAd({ pid, slot }) {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    const image = new Image(1, 1);
    const params = new URLSearchParams({
        pid,
        r: document.referrer,
        p: window.location.pathname,
        s: slot,
    });
    image.src = `/txs.gif?${params.toString()}`;
    document.body.appendChild(image);
}

export default function createObserver(target, { hooks = {}, options = {} } = {}) {
    let timer = null;
    let visible = false;
    let tracked = false;
    const reset = () => {
        clearTimeout(timer);
        timer = null;
    };
    const start = () => {
        if (!visible || document.hidden || tracked || timer !== null) return;
        timer = setTimeout(() => {
            timer = null;
            if (!visible || document.hidden || tracked) return;
            tracked = true;
            if (target.delivery_token) trackDelivery(target, 'impression');
            else trackAd(target);
        }, options.adTTL ?? 1000);
    };
    const visibilityChanged = () => {
        reset();
        start();
    };
    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                if (visible) {
                    hooks.onVisible?.();
                    start();
                } else {
                    reset();
                    hooks.onHidden?.();
                    if (entry.intersectionRatio === 0 && tracked) hooks.onReplace?.();
                }
            }
        },
        options.observer ?? { root: null, threshold: [0, 0.5] },
    );
    const expires = target.expires_at
        ? setTimeout(
              () => {
                  reset();
                  visible = false;
                  observer.disconnect();
                  hooks.onReplace?.();
              },
              Math.max(0, Date.parse(target.expires_at) - Date.now()),
          )
        : null;
    const click = () => trackDelivery(target, 'click');
    target.el.addEventListener?.('click', click);
    target.el.addEventListener?.('auxclick', click);
    document.addEventListener('visibilitychange', visibilityChanged);
    observer.observe(target.el);
    return () => {
        reset();
        clearTimeout(expires);
        target.el.removeEventListener?.('click', click);
        target.el.removeEventListener?.('auxclick', click);
        observer.disconnect();
        document.removeEventListener('visibilitychange', visibilityChanged);
    };
}
